export default "__VITE_ASSET__6b1d4607__"